module.exports = __webpack_public_path__ + "static/media/snapfire.bacb0d58.png";